<ng-container *ngIf="page && page?.totalElements == 0">
  <h2>geen overige transacties gevonden</h2>
  <p>
    voor dit rapportagejaar zijn er geen transacties gecategoriseerd onder 'overige inkomsten' of 'overige uitgaven'.
  </p>
</ng-container>

<ng-container *ngIf="page?.totalElements != 0">
  <p class="align-center f20">
    let op: u heeft transactie(s) gecategoriseerd als overige inkomsten/uitgaven <br>
    deze transacties moeten gespecificeerd en toegelicht worden in de bijlage
  </p>
  <div class="spacer-large"></div>
  <mat-paginator *ngIf="page?.totalElements > defaultPageSize"
                 [length]="page?.totalElements"
                 [pageSize]="event.pageSize"
                 [pageSizeOptions]="[defaultPageSize * 2, defaultPageSize * 5, defaultPageSize * 10]"
                 (page)="event = update($event)">
  </mat-paginator>
  <table matSort (matSortChange)="sortPage($event)" class="table">
    <tr>
      <th mat-sort-header="valueDate" style="width: 150px">datum</th>
      <th mat-sort-header="calculatedAmount" style="width: 150px">bedrag</th>
      <th mat-sort-header="iban" style="width: 250px">IBAN</th>
      <th mat-sort-header="transactionDescription">omschrijving</th>
    </tr>
    <tr *ngFor="let row of page?.content" style="margin-bottom: 20px;">
      <td>{{ row.valueDate }}</td>
      <td class="mono-space">
        {{ currencyService.symbol(row.currency) }}
        {{ currencyService.format(row.calculatedAmount) }}
      </td>
      <td>{{ row.iban ? row.iban : '-' }}</td>
      <td>{{ row.transactionDescription }}</td>
    </tr>
  </table>
</ng-container>
